import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/oferta';
export function FaqSection() {
  const [abierta, setAbierta] = useState<number | null>(0);
  return <section aria-labelledby="faq-titulo" className="border-b border-violet-line/40 bg-violet-deep" data-id="element-7" data-mp="1bmllx5jgptjf">
      <div className="mx-auto max-w-3xl px-6 py-20 sm:py-24 lg:px-8" data-id="element-8" data-mp="2496ci3s461lx">
        <h2 id="faq-titulo" className="font-serif text-3xl font-medium leading-tight text-bone sm:text-4xl" data-id="element-9" data-mp="249zllbejp378">
          Preguntas frecuentes
        </h2>

        <dl className="mt-10 divide-y divide-violet-line/70 border-t border-violet-line/70" data-id="element-10" data-mp="1uilh0p7qld78">
          {faqs.map((faq, i) => {
          const activa = abierta === i;
          return <div key={faq.pregunta} data-id="element-11" data-mp="2n7a9jzuq8a7d" data-mpi={i}>
                <dt data-id="element-12" data-mp="2n67jfu58absi">
                  <button type="button" onClick={() => setAbierta(activa ? null : i)} aria-expanded={activa} className="flex w-full items-start justify-between gap-6 py-5 text-left font-sans text-base font-medium text-bone transition-colors duration-150 ease-out hover:text-gold-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-13" data-mp="2ryikx1fma5n6">
                    <span data-id="element-14" data-mp="19su1ruypeya5">{faq.pregunta}</span>
                    <PlusIcon aria-hidden="true" className="mt-0.5 h-5 w-5 flex-none text-gold transition-transform duration-200 ease-out" style={{
                  transform: activa ? 'rotate(45deg)' : 'rotate(0deg)'
                }} data-id="element-15" data-mp="1oj19pgr34ywl" />
                  </button>
                </dt>
                <AnimatePresence initial={false} data-id="element-16" data-mp="35yg1hhpmpgo">
                  {activa && <motion.dd key="respuesta" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-17" data-mp="3816g2mryklx">
                      <p className="pb-6 pr-10 font-sans text-base font-light leading-relaxed text-bone/70" data-id="element-18" data-mp="2c9npihtx99p2">
                        {faq.respuesta}
                      </p>
                    </motion.dd>}
                </AnimatePresence>
              </div>;
        })}
        </dl>
      </div>
    </section>;
}